import type { SVGProps } from 'react';
const SvgSettingsBluetooth = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#settings_bluetooth_svg__a)">
      <path
        fill="currentColor"
        d="M11 24h2v-2h-2v2Zm-4 0h2v-2H7v2Zm8 0h2v-2h-2v2Zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29ZM13 3.83l1.88 1.88L13 7.59V3.83Zm1.88 10.46L13 16.17v-3.76l1.88 1.88Z"
      />
    </g>
    <defs>
      <clipPath id="settings_bluetooth_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSettingsBluetooth;
